<header class="flex header">
  <h2>
    {{ 'greigeInfoModal.title' | translateWF: 'Greige Detail' }}
  </h2>
  <p-button icon="pi pi-times" (click)="onClose()" />
</header>
<section class="content">
  <app-card-composition [fabricComposition]="greige"></app-card-composition>
</section>
<footer>
  <p-button class="w-full" label="Exit" variant="outlined" (click)="onClose()" />
</footer>
